import { FormInitialisationMode } from '../../models';

export const INITIALISATION_MODE_MAP = {
    [FormInitialisationMode.Add]: 'inAddMode',
    [FormInitialisationMode.Delete]: 'inDeleteMode',
    [FormInitialisationMode.Edit]: 'inEditMode',
};
